import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import PastWishesItem from "./past-wishes-item/PastWishesItem";
import Box from "@mui/material/Box";
import {RootState, useAppDispatch, useAppSelector} from "../../../store";
import {useEffect, useMemo} from "react";
import {getPastWinners} from "../../../store/wish/ActionCreators";
import useWindowDimensions from "../../../util/hooks/useWindowDimensions";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from 'swiper/modules';

import IconButton from "@mui/material/IconButton";
import {ArrowBackIosRounded, ArrowForwardIosRounded} from "@mui/icons-material";

const PastWishes = () => {
    const {t} = useTranslation()
    const pastWinners = useAppSelector((state: RootState) => state.wishReducer.pastWinners)
    const dispatch = useAppDispatch()
    const {width} = useWindowDimensions()

    const numberOfWishes = useMemo(() => {
        let newNumber
        if (!width) return 1;
        if (width < 600) newNumber = 1;
        else if (width < 900) newNumber = 2;
        else if (width < 1200) newNumber = 3;
        else newNumber = 4;

        if (newNumber > pastWinners.length && !!pastWinners.length)
            newNumber = pastWinners.length

        return newNumber
    }, [width, pastWinners.length]);

    const shouldShowNavigation = pastWinners.length > numberOfWishes;

    useEffect(() => {
        dispatch(getPastWinners())
    }, [dispatch])

    return (
        pastWinners.length ? <Box mt={8}>
            <Typography variant="h4" color="primary" fontWeight={600}>
                {t('past_winners')}
            </Typography>
            <Swiper
                modules={[Navigation]}
                spaceBetween={20}
                slidesPerView={numberOfWishes}
                navigation={shouldShowNavigation ? {
                    nextEl: '.swiper-button-next-past-winners',
                    prevEl: '.swiper-button-prev-past-winners',
                } : false}
                cssMode
                rewind={shouldShowNavigation}
                style={{marginTop: "1em"}}
            >
                {pastWinners.map(w => (
                    <SwiperSlide key={w.id} style={{display: 'flex', justifyContent: 'center', height: 'auto'}}>
                        <PastWishesItem wish={w}/>
                    </SwiperSlide>
                ))}
                {shouldShowNavigation && (
                    <>
                        <IconButton color="primary" className="swiper-button-prev-past-winners" aria-label="previous"
                                    sx={{
                                        position: 'absolute',
                                        left: 0,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        zIndex: 10
                                    }}>
                            <ArrowBackIosRounded/>
                        </IconButton>
                        <IconButton color="primary" className="swiper-button-next-past-winners" aria-label="next" sx={{
                            position: 'absolute',
                            right: 0,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 10
                        }}>
                            <ArrowForwardIosRounded/>
                        </IconButton>
                    </>
                )}
            </Swiper>
        </Box> : null
    )
}

export default PastWishes
